"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../../core/utils/index");

var MetadataReportDTO_1 = require("../../report/model/MetadataReportDTO");

var MetadataReportDTOConverter_1 = require("./MetadataReportDTOConverter");

var MetadataReportDTOConverterImpl =
/*#__PURE__*/
function (_MetadataReportDTOCon) {
  _inherits(MetadataReportDTOConverterImpl, _MetadataReportDTOCon);

  function MetadataReportDTOConverterImpl() {
    _classCallCheck(this, MetadataReportDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(MetadataReportDTOConverterImpl).apply(this, arguments));
  }

  _createClass(MetadataReportDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new MetadataReportDTO_1.MetadataReportDTO(MetadataReportDTO_1.MetadataReportDTO.schema.productExternalId.valueOfField(source), MetadataReportDTO_1.MetadataReportDTO.schema.productName.valueOfField(source), MetadataReportDTO_1.MetadataReportDTO.schema.siteExternalId.valueOfField(source), MetadataReportDTO_1.MetadataReportDTO.schema.siteName.valueOfField(source), MetadataReportDTO_1.MetadataReportDTO.schema.productActive.valueOfField(source), MetadataReportDTO_1.MetadataReportDTO.schema.addToPortfolioDate.valueOf(index_1.Utils.isValueMissing(source.addToPortfolioDate) ? null : source.addToPortfolioDate));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        productExternalId: source.productExternalId,
        productName: source.productName,
        siteExternalId: source.siteExternalId,
        siteName: source.siteName,
        productActive: source.productActive,
        addToPortfolioDate: index_1.Utils.isValueMissing(source.addToPortfolioDate) ? null : conversions.fromDate(source.addToPortfolioDate)
      });
      return result;
    }
  }]);

  return MetadataReportDTOConverterImpl;
}(MetadataReportDTOConverter_1.MetadataReportDTOConverter);

exports.MetadataReportDTOConverterImpl = MetadataReportDTOConverterImpl;